<template>
    <b-container class="m-15-0 p-0">

		<b-row class="m-0 p-0 v-center">

			<b-col md="auto" class="m-0 p-0"
				   @click="parentTag.changeVisible()">
				<font-awesome-icon icon="caret-down"
								   size="2x"
								   id="sorting-list-caret"
								   :class="parentTag.IsShow ? 'sorting-list-caret-up' : 'sorting-list-caret-down'" />
			</b-col>

			<b-col md="auto" class="sorting-list-name m-0 pl-0 pr-0">
				{{parentTag.Name}}
			</b-col>

			<b-col md="auto" class="m-0 p-0">
				<a href="" @click="moveToEdit(parentTag)">
					<font-awesome-icon icon="pen" class="sorting-icon" />
				</a>
			</b-col>

			<b-col md="auto" class="m-0 p-0">
				<div class="pointer" @click="deleteParentTag()">
					<font-awesome-icon icon="trash-alt" class="sorting-icon" />
				</div>
			</b-col>

			<b-col md="auto" class="parent-handle m-0 p-0">
				<font-awesome-icon icon="arrows-alt" class="sorting-icon pointer" />
			</b-col>

		</b-row>

        <hr class="hr-parent">

		<transition name="visibility-switch">
			<draggable v-if="parentTag.IsShow"
					class="row m-0 p-0"
					v-model="parentTag.SubTags"
					:group="'subTags_' + parentTag.Id"
					v-bind="{ handle:'.sub-handle', animation:150 }"
					@input="setIsChanged">

				<b-col class="m-0"
					:class="index % 2 == 1 ? 'pr-0' : 'pl-0' "
					cols="6"
					v-for="(item, index) in parentTag.SubTags"
					:key="item.Id" >

					<b-row class="p-0 ml-15 v-center">
						<b-col md="auto" class="m-0 p-0 v-center">
							<b-img rounded
								   v-bind="{ blank: true, width: 15, height: 15, class: 'm1' }"						   
								   :blank-color="item.Color"
								   class="mr-10"  />
						</b-col>

						<b-col md="auto" class="sorting-list-subname m-0 pl-0 pr-0">
							{{item.Name}}
						</b-col>

						<b-col md="auto" class="m-0 p-0">
							<a href="" @click="moveToEdit(item)">
								<font-awesome-icon icon="pen" class="sorting-icon" />
							</a>
						</b-col>

						<b-col md="auto" class="m-0 p-0">
							<div class="pointer" @click="deleteSubTagDialog(index)">
								<font-awesome-icon icon="trash-alt" class="sorting-icon" />
							</div>
						</b-col>

						<b-col md="auto" class="sub-handle m-0 p-0">
							<font-awesome-icon icon="arrows-alt" class="sorting-icon pointer" />
						</b-col>

						<b-col cols="12" class="m-0 p-0">
							<hr class="hr-sub">

						</b-col>
					</b-row>

				</b-col>

			</draggable>
		</transition>
    </b-container>
</template>

<script>
import dialogService from '@/services/dialog.service'
import AllRoutes from '@/routes/all.routes';

export default {
    model: {
        event: 'deleteParentTag'
    },
    props: {
        parentTagIndex: {
            type: Number,
            default: 0
        },
        parentTag: {
            type: Object,
            default: null
		},
		editLink: {
			type: String,
			default: "/Admin/Tags/StandardsBook/Edit"
		},
        apiVersion: {
            type: String,
            default: ""
        }
    },
    methods: {
        
        deleteSubTagDialog: function(index) {
            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данный тег?')
            .then(ok => {
                this.parentTag.SubTags.splice(index, 1);
                this.$emit('change', true);
            })
            .catch(cancel => { return });
        },

        deleteParentTag: function() {
            this.$emit("remove", this.parentTagIndex);
        },

        setIsChanged: function() {
            this.$emit('change', true);
		},
		
		moveToEdit: function(item) {
			this.$router.push(`${this.editLink}?id=${item.Id}&api-Version=${this.apiVersion}`);
		}

    }
}
</script>